<template>
	<div id="app">
		<!-- 导航栏 -->
		<floatTip></floatTip>
		<pageHeader :banner="BigbannerList" :bannerlogo="bannerLogo"></pageHeader>
		<navBar :navlist="topNavList"></navBar>

		<div class="assocProfile_father">
			<!-- 协会简介主体 -->
			<div class="assocProfile" v-if="Stype === 1">
				<tab-bar v-if="Stype === 1" :navtitle="webTitle" :navlist="navList" @navrefresh="navrefresh">
				</tab-bar>
				<div class="assocRight">
					<bread-crumbs :place="place"></bread-crumbs>
					<div class="assocRightBody" v-html="contentDetail.content" v-if="contentDetail">
					</div>
				</div>
			</div>
			<!-- 党建引领 -->
			<div class="assocProfile" v-else-if="type === 0 || type === 1">
				<tab-bar :navtitle="webTitle" :navlist="navList" :issecond="secondList" @openfresh="freshopen"
					@navrefresh="navrefresh"></tab-bar>
				<div class="assocRight">
					<bread-crumbs :place="place"></bread-crumbs>
					<div v-if="mediaShow">
						<div class="newContent_Father" v-for="(item,index) in dataList" :key="index"
							@click="showDDetail(item.id)">
							<div class="newContent_list">
								<div class="listp">
									<p>·</p>
									<p>{{item.news_title}}</p>
								</div>
								<p class="sd_content_p">{{item.publish_time}}</p>
							</div>
							<div class="dashed_more">
							</div>
						</div>

						<div class="assocpagination" v-if="totalNum>10">
							<el-pagination :small="isSmall" @size-change="handleSizeChange"
								@current-change="handleCurrentChange" :current-page="currentPage"
								:page-sizes="[10, 20, 40]" :page-size="pageSize" :layout="isLayout" :total="totalNum"
								background>
							</el-pagination>
						</div>

					</div>

					<div v-else>
						<div class="mediaContet">
							<div class="mediaList" v-for="(item,index) in mediaDetail" :key="index">
								<div class="mediaLeft">
									<img :src="item.pic_path">
								</div>
								<div class="mediaRight">
									<p class="mediaRight_p1">{{item.title}}</p>
									<p class="mediaRight_p2">发布时间：|&nbsp;&nbsp;{{item.created_at}}</p>
									<div class="mediaRight_bot">
										<p @click="downs(item,'preview')">预览</p>
										<p @click="downs(item,'download')">下载</p>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			<!-- 分支机构适用 -->
			<div class="assocProfile" v-if="type === 2">
				<div class="branchContet">
					<div class="branchList" v-for="(item,index) in branchList" :key="index">
						<div v-show="item.picture" @click="navBranch(item)">
							<div class="listTop">
								<img :src="item.picture">
							</div>
							<p>{{item.name}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 首页底部抽取 -->
		<pageFooter :indexinfo="indexInfo"></pageFooter>

	</div>
</template>

<script>
	import tabBar from './components/tabBar.vue'
	import breadCrumbs from './components/breadCrumbs.vue'
	import pageFooter from './components/pageFooter.vue'
	import pageHeader from './components/pageHeader.vue'
	import navBar from './components/navBar.vue'
	import floatTip from './components/floatTip.vue'

	import {
		apiRequest
	} from './assets/js/axios/request.js'

	import {
		changeFavicon
	} from './assets/js/utils/utils.js'


	export default {
		name: 'app',
		components: {
			tabBar,
			breadCrumbs,
			pageFooter,
			pageHeader,
			navBar,
			floatTip
		},
		data() {
			return {
				bannerLogo: '',
				indexInfo: {},
				isLayout: 'total,sizes, prev, pager, next, jumper',
				isSmall: false,
				topNav: true,
				// 网页轮播
				BigbannerList: {},
				// 网页标题
				webTitle: '',
				// 是否有二级导航栏
				secondList: true,
				// 二级打开栏
				openfresh: '',
				mediaShow: true,
				mediaDetail: [],

				Stype: -1,
				searchInput: '',
				place: {
					one: '',
					two: ''
				},
				topNavList: [],
				navList: [],
				contentDetail: '',
				type: -1,
				dataList: [],
				branchList: [],
				// 分页
				currentPage: 1,
				totalNum: 0,
				pageSize: 10,
			}
		},
		created() {
			this.getNavList()
			this.getBasicInfo()
			let urlParams = window.location.pathname.split('/')
			const arqParams = urlParams[urlParams.length - 1]
			this.getSecondList(arqParams)
		},
		methods: {
			/* 获取企业前缀*/
			async getCompony(firstName) {
				await apiRequest({
					method: 'post',
					url: '/appapi/login/get-company',
					data: {},
					success: (res) => {
						document.title = firstName + '-' + res.data.company_name
					}
				})
			},
			// 跳转分支机构
			navBranch(item) {
				if (item.link) {
					window.location.href = './' + item.link
				} else {
					if (!!window.ActiveXObject || 'ActiveXObject' in window) {
						const url = 'branchdetail.html?id=' + item.id
						window.open(url, '_self')
					} else {
						const a = document.createElement('a')
						const event = new MouseEvent('click')
						a.href = 'branchdetail.html?id=' + item.id
						a.target = '_self'
						a.dispatchEvent(event);
					}
				}
			},
			// 获取每一页的banner图
			getBanner(column_code) {
				apiRequest({
					method: 'post',
					url: '/adminapi/web/get-web-banner',
					data: {
						column_code
					},
					success: (res) => {
						this.BigbannerList = res.data[0]
					}
				})
			},
			showDDetail(e) {
				if (!!window.ActiveXObject || 'ActiveXObject' in window) {
					const url = 'detail.html?id=' + e
					window.open(url, '_self')
				} else {
					const a = document.createElement('a')
					const event = new MouseEvent('click')
					a.href = 'detail.html?id=' + e
					a.target = '_self'
					a.dispatchEvent(event);
				}
			},
			// 获取路由参数
			getQueryParams(variable) {
				let href = window.location.href
				let query = href.substring(href.indexOf("?") + 1)
				let vars = query.split("&")
				for (let i = 0; i < vars.length; i++) {
					let pair = vars[i].split("=")
					if (pair[0] === variable) {
						return pair[1]
					}
				}
				return (false)
			},
			// 下载
			downs(item, type) {
				if (type === 'preview') {
					apiRequest({
						method: 'post',
						url: '/adminapi/web/send-media-record',
						data: {
							id: item.id
						},
						success: (res) => {
							// //console.log(res)
						}
					})
				}
				window.open(item.file_path, '_blank')
			},
			handleSizeChange(val) {
				// 每页显示数
				this.pageSize = val
				this.getInformation()
			},
			handleCurrentChange(val) {
				// 第几页
				this.currentPage = val
				this.getInformation()
			},
			// 基础信息
			async getBasicInfo() {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-web-base-info',
					data: {
						column_code: '5F8B3D07-841C-E204-58D9-3FF4BCEE4765'
					},
					success: (res) => {
						let icon = res.data.icon
						this.bannerLogo = res.data.logo
						changeFavicon(icon)
						this.indexInfo = res.data
					}
				})
			},
			// 导航栏
			async getNavList() {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-web-nav',
					data: {
						position: 1
					},
					success: (res) => {
						this.topNavList = res.data
					}
				})
			},
			// 获取二级栏目
			async getSecondList(link) {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-column-children',
					data: {
						link
					},
					success: (res) => {
						// console.log('获取到的二级栏目',res)
						const {
							model,
							type,
							column_code,
							banner_code
						} = res.data
						this.navList = res.data.children
						this.type = res.data.type
						this.webTitle = res.data.column_name
						this.place.one = res.data.column_name
						this.getCompony(res.data.column_name)

						// 获取每一页的banner图
						this.getBanner(banner_code)

						// 争先创优-二级列表
						if (model === 1 && type === 1) {
							// // 新增二级分级导航栏
							this.secondList = false
						}
						// 分支机构需要单独的处理
						if (type === 2) {
							const {
								column_code
							} = res.data
							this.getBranch(column_code)
						}
						// 无侧边栏情况
						if (!res.data.children.length) {
							this.column_code = column_code
							this.getInformation(column_code)
						}
					}
				})
			},
			// 获取分支机构
			async getBranch(column_code) {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-organization',
					data: {
						column_code
					},
					success: (res) => {
						// console.log("分支机构", res.data)
						let branchList = res.data
						const branchStr = String((branchList.length / 3).toFixed(1)).split('.')[1]
						if (branchStr === '3') {
							// console.log('缺两个')
							//缺两个
							// for (let i in 2) {
							// 	const param = {}
							// 	branchList.push(param)
							// }
							branchList = [...branchList, {}, {}]
						} else if (branchStr === '7') {
							// console.log('缺一个')
							// 缺一个
							const param = {}
							branchList.push(param)
						}
						this.branchList = branchList
					}
				})
			},
			// 获取栏目咨询列表
			async getInformation(column_code) {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-web-news-list',
					data: {
						column_code: column_code ? column_code : this.column_code,
						pageNo: this.currentPage,
						pageSize: this.pageSize
					},
					success: (res) => {
						this.dataList = res.data
						this.totalNum = parseInt(res.total)
					}
				})
			},
			// 获取单页内容
			async getSingeContent(column_code) {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-signal-page',
					data: {
						column_code
					},
					success: (res) => {
						this.contentDetail = res.data
					}
				})
			},
			// 获取电子会刊
			async getEbookList(column_code) {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-media',
					data: {
						column_code
					},
					success: (res) => {
						this.mediaDetail = res.data
					}
				})
			},
			freshopen(e) {
				this.openfresh = e
			},
			navrefresh(e) {
				if(this.navList[e].link == '开发中'){
					this.$message('开发中...');	
					return
				}
				// 如果不存在二级
				if (this.secondList) {
					this.place.two = this.navList[e].label
					const {
						key,
						model,
						link
					} = this.navList[e]

					this.column_code = key
					//console.log(model)
					if (model === '7') {
						this.Stype = 1
						// 单页面内容
						this.getSingeContent(key)
					} else if (model === '1') {
						this.mediaShow = true
						// 获取栏目咨询列表
						this.getInformation(key)
					} else if (model === '8') {
						// 电子会刊特殊
						this.mediaShow = false
						this.getEbookList(key)
					} else if (model === '0') {
						// 链接式网站
						if (link) {
							if (!!window.ActiveXObject || 'ActiveXObject' in window) {
								window.open(link, '_blank')
								setTimeout(() => {
									const url = window.location.pathname.split('?')[0]
									window.location.replace(url)
								}, 0)
							} else {
								const a = document.createElement('a')
								const event = new MouseEvent('click')
								a.href = link
								a.target = '_blank'
								a.dispatchEvent(event);
								setTimeout(() => {
									const url = window.location.pathname.split('?')[0]
									window.location.replace(url)
								}, 0)
							}
						}
					} else if (model === '9') {
						if (!!window.ActiveXObject || 'ActiveXObject' in window) {
							const url = './' + link
							window.open(url, '_self')
						} else {
							// 内部网页网站
							const a = document.createElement('a')
							const event = new MouseEvent('click')
							a.href = './' + link
							a.target = '_self'
							a.dispatchEvent(event);
						}
					}
				} else {
					// 如果存在二级,非首次
					if (typeof e === 'number') {
						const {
							model,
							key,
							link
						} = this.navList[this.openfresh].children[e]
						this.column_code = key

						this.place.two = this.navList[this.openfresh].children[e].label
						if (model === '7') {
							this.Stype = 1
							// 单页面内容
							this.getSingeContent(key)
						} else if (model === '1') {
							this.mediaShow = true
							// 获取栏目咨询列表
							this.getInformation(key)
						} else if (model === '8') {
							// 电子会刊特殊
							this.mediaShow = false
							this.getEbookList(key)
						} else if (model === '0') {
							// 链接式网站
							if (link) {
								if (!!window.ActiveXObject || 'ActiveXObject' in window) {
									window.open(link, '_blank')
									setTimeout(() => {
										const url = window.location.pathname.split('?')[0]
										window.location.replace(url)
									}, 0)
								} else {
									const a = document.createElement('a')
									const event = new MouseEvent('click')
									a.href = link
									a.target = '_blank'
									a.dispatchEvent(event);
									setTimeout(() => {
										const url = window.location.pathname.split('?')[0]
										window.location.replace(url)
									}, 0)
								}
							}
						} else if (model === '9') {
							if (!!window.ActiveXObject || 'ActiveXObject' in window) {
								const url = './' + link
								window.open(url, '_self')
							} else {
								// 内部网页网站
								const a = document.createElement('a')
								const event = new MouseEvent('click')
								a.href = './' + link
								a.target = '_self'
								a.dispatchEvent(event);
							}
						}
					} else {
						//首次默认点击
						const ceList = e.split('-')
						this.openfresh = ceList[0]
						const {
							model,
							key,
							link
						} = this.navList[ceList[0]].children[ceList[1]]
						this.column_code = key

						this.place.two = this.navList[ceList[0]].children[ceList[1]].label
						if (model === '7') {
							this.Stype = 1
							// 单页面内容
							this.getSingeContent(key)
						} else if (model === '1') {
							this.mediaShow = true
							// 获取栏目咨询列表
							this.getInformation(key)
						} else if (model === '8') {
							// 电子会刊特殊
							this.mediaShow = false
							this.getEbookList(key)
						} else if (model === '0') {
							// 链接式网站
							if (link) {
								if (!!window.ActiveXObject || 'ActiveXObject' in window) {
									window.open(link, '_blank')
									setTimeout(() => {
										const url = window.location.pathname.split('?')[0]
										window.location.replace(url)
									}, 0)
								} else {
									const a = document.createElement('a')
									const event = new MouseEvent('click')
									a.href = link
									a.target = '_blank'
									a.dispatchEvent(event);
									setTimeout(() => {
										const url = window.location.pathname.split('?')[0]
										window.location.replace(url)
									}, 0)
								}
							}
						} else if (model === '9') {
							if (!!window.ActiveXObject || 'ActiveXObject' in window) {
								const url = './' + link
								window.open(url, '_self')
							} else {
								// 内部网页网站
								const a = document.createElement('a')
								const event = new MouseEvent('click')
								a.href = './' + link
								a.target = '_self'
								a.dispatchEvent(event);
							}
						}
					}
				}
			}
		}

	}
</script>

<style>
	/* 渐变背景 */
	.specil_bg {
		width: 100%;
		height: 261px;
		background: linear-gradient(180deg, #125DB2 0%, #FFFFFF 100%);
	}

	/* 图片 */
	.assocRightBody>img,
	.assocRightBody>p>img {
		max-width: 100%;
	}
	
	.assocRightBody table {
		border: 1px solid #ccc;
	}
	
	.assocRightBody table th,
	.assocRightBody table td {
		border: 1px solid #ccc;
	}
	
	.assocRightBody table td {
		padding: 0px 5px;
	}
</style>
